module.exports = __webpack_public_path__ + "img/rws-parking.c52edced.png";